import { useState, useEffect, useRef } from "react";

export const VelocityInput = ({ value, onChange, disabled }) => {
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    setInputValue(value != null ? String(value) : "");
  }, [value]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    if (newValue === "") {
      onChange(null);
      return;
    }
    const numValue = parseInt(newValue, 10);
    if (!isNaN(numValue) && numValue >= 50 && numValue <= 100) {
      onChange(numValue);
    }
  };

  const handleSliderChange = (e) => {
    const newValue = parseInt(e.target.value, 10);
    setInputValue(String(newValue));
    onChange(newValue);
  };

  const handleInputBlur = () => {
    const numValue = parseInt(inputValue, 10);
    if (!inputValue || isNaN(numValue) || numValue < 50 || numValue > 100) {
      setInputValue(value != null ? String(value) : "");
    }
  };

  const sliderValue = value != null && typeof value === "number" ? value : 75;

  return (
    <div className="space-y-1">
      <label className="text-sm font-medium text-gray-700 block">
        Velocity (mph)
      </label>
      <div className="flex items-center gap-2 sm:gap-3">
        <input
          ref={inputRef}
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
          className="w-12 sm:w-16 px-2 py-1 border border-gray-200 rounded-md text-center
            focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500
            text-sm font-medium"
          placeholder="-"
          disabled={disabled}
        />
        <div className="flex-1 flex items-center gap-1 sm:gap-2">
          <span className="text-xs text-gray-500">50</span>
          <input
            type="range"
            min="50"
            max="100"
            value={sliderValue}
            onChange={handleSliderChange}
            className="flex-1 h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer
              focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            disabled={disabled}
          />
          <span className="text-xs text-gray-500">100</span>
        </div>
      </div>
    </div>
  );
};
